"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryInfo = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const CategoryInfoView_1 = require("./views/CategoryInfoView");
function CategoryInfo({ slug }) {
    const { data } = (0, app_1.useQuery)('getProductCategory', {
        args: {
            slug,
        },
        select: {
            description: true,
            title: true,
        },
    });
    return ((0, jsx_runtime_1.jsx)(CategoryInfoView_1.CategoryInfoView, { description: data === null || data === void 0 ? void 0 : data.description, category: data === null || data === void 0 ? void 0 : data.title }));
}
exports.CategoryInfo = CategoryInfo;
